import { apiSlice } from '../apiSlice';
import { MESSAGES } from './analyticsMessages';
import { API_TAGS } from '../../constants/api';
import { API_REPORTS_URL } from '../../constants/env';
import handleBlobTypes from '../utils/handleBlobTypes';

// Reuse the createEndpoint function for defining individual analytics fetch queries
const createEndpoint = (builder, path, errorMessage) => {
  return builder.query({
    query: ({ orgId, token, urlParams = {} }) => ({
      url: `organizations/${orgId}/analytics/${path}`,
      method: 'GET',
      extraToken: token,
      maxRetries: 3,
      params: {
        ...urlParams
      },
      errorMessage: {
        showMessage: true,
        messages: errorMessage
      }
    }),
    providesTags: (result, error, args) => {
      return [{ type: API_TAGS.ANALYTICS, id: path }]; // Use path as a unique identifier for caching
    }
  });
};

export const analyticsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchAnalyticsSummary: createEndpoint(builder, 'summary', MESSAGES.FETCH_ANALYTICS.ERROR),
    fetchLiveChatAnalytics: createEndpoint(builder, 'live-chat', MESSAGES.FETCH_ANALYTICS.ERROR),
    fetchAutomatedAnswersAnalytics: createEndpoint(builder, 'automated-answers', MESSAGES.FETCH_ANALYTICS.ERROR),
    fetchInterviewsAnalytics: createEndpoint(builder, 'interviews', MESSAGES.FETCH_ANALYTICS.ERROR),
    fetchDecisionTreesAnalytics: createEndpoint(builder, 'decision-trees', MESSAGES.FETCH_ANALYTICS.ERROR),
    fetchUserFeedbackAnalytics: createEndpoint(builder, 'user-feedback', MESSAGES.FETCH_ANALYTICS.ERROR),
    fetchMissedQuestionsAnalytics: createEndpoint(builder, 'missed-questions', MESSAGES.FETCH_ANALYTICS.ERROR),
    fetchCSATAnalytics: createEndpoint(builder, 'csat', MESSAGES.FETCH_ANALYTICS.ERROR),
    exportAnalyticsReport: builder.query({
      query: ({ orgId, urlParams = {} }) => ({
        url: `organization/${orgId}/report/export`,
        method: 'GET',
        API_URL: API_REPORTS_URL,
        params: {
          ...urlParams
        },
        extraHeaders: {
          Accept: 'application/pdf',
          'Content-Type': 'application/pdf'
        },
        responseType: 'blob',
        includeResponseHeaders: true,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.EXPORT_ANALYTICS_REPORT.ERROR
        },
        successMessage: {
          showMessage: true,
          messages: MESSAGES.EXPORT_ANALYTICS_REPORT.SUCCESS
        }
      }),
      transformResponse: (response) => {
        return handleBlobTypes(response, true);
      }
    })
  })
});

export const {
  useFetchAnalyticsSummaryQuery,
  useLazyFetchAnalyticsSummaryQuery,
  useFetchLiveChatAnalyticsQuery,
  useLazyFetchLiveChatAnalyticsQuery,
  useFetchAutomatedAnswersAnalyticsQuery,
  useLazyFetchAutomatedAnswersAnalyticsQuery,
  useFetchInterviewsAnalyticsQuery,
  useLazyFetchInterviewsAnalyticsQuery,
  useFetchDecisionTreesAnalyticsQuery,
  useLazyFetchDecisionTreesAnalyticsQuery,
  useFetchUserFeedbackAnalyticsQuery,
  useFetchMissedQuestionsAnalyticsQuery,
  useLazyFetchMissedQuestionsAnalyticsQuery,
  useLazyFetchUserFeedbackAnalyticsQuery,
  useLazyExportAnalyticsReportQuery,
  useFetchCSATAnalyticsQuery,
  useLazyFetchCSATAnalyticsQuery
} = analyticsSlice;
